import axios from "axios";
import { clearSession, getStoredUser, isTokenExpired } from "./session";

// Ruta relativa: la app siempre habla con el /api/ del mismo dominio que la sirve.
// Asi un cambio de dominio no vuelve a romper el frontend.
const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || "/api/",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    Accept: "application/json",
  },
});

const goToLogin = () => {
  clearSession();
  if (window.location.pathname !== "/login") {
    window.location.replace("/login?sesion=expirada");
  }
};

// El token se lee en CADA peticion. Antes se leia una sola vez al cargar el
// modulo, asi que la cabecera quedaba congelada con el token del arranque.
instance.interceptors.request.use((config) => {
  const user = getStoredUser();
  if (user && user.token && !isTokenExpired(user.token)) {
    config.headers.Authorization = "Bearer " + user.token;
  } else {
    delete config.headers.Authorization;
  }
  return config;
});

// Sesion vencida: cerrar y mandar al login en vez de fallar en silencio.
// Un 403 con token todavia vigente es falta de permisos, no expiracion:
// ese se deja pasar para que la pantalla muestre su propio mensaje.
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    const esLogin = url.indexOf("auth/signin") !== -1;
    if ((status === 401 || status === 403) && !esLogin) {
      const user = getStoredUser();
      if (!user || !user.token || isTokenExpired(user.token)) {
        goToLogin();
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
